export class PdfFreeReceiptDto {
    id?: number;
    label?: string;
    url?: string;
}
